import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
  Grid,
} from '@material-ui/core';
import ChevronDown from '../../../empadronamiento/UI/ChevronDown';
import { traerEstudiosMedicos, traerEstudiosSolicitados } from '../../../../actions/hce/hceActions';
import { ModalIngresoEstudioSolicitado } from './ModalIngresoEstudioSolicitado';
import { EstudiosSolicitadosItem } from './EstudiosSolicitadosItem';



export const TabEstudiosSolicitados = (props) => {

  const { estudiosSolicitados, estudiosMedicos } = useSelector((state) => state.hce);
  const { hce } = props;
  const dispatch = useDispatch();
  const [openModalEstudios, setOpenModalEstudios] = useState(false);
  const [tituloModal, setTituloModal] = useState('');


  useEffect(() => {
    dispatch(traerEstudiosSolicitados(hce.idAfiliado, hce.idAfiliadoExterno));
    dispatch(traerEstudiosMedicos());
  }, [dispatch]);



  return (
    <>
      {openModalEstudios && (
        <ModalIngresoEstudioSolicitado
          open={openModalEstudios}
          close={() => {
            setOpenModalEstudios(false);
          }}
          titulo={tituloModal}
          disabled={props.disabled}
          hce={hce}
          estudiosMedicos={estudiosMedicos}
        />
      )}
      <Grid container spacing={3}>
        <Grid item xs={12} md={3} lg={3} style={{ textAlign: 'start', margin: '1rem 0' }}>
          <Button
            style={{
              fontSize: '0.8rem',
              padding: 10,
            }}
            variant="contained"
            color="primary"
            onClick={() => {
              const url = 'https://microgen.servebbs.com/interpracsysweb/';
              window.open(url, '_blank');
            }}
          >
            Acceso a Microgen - Analisis Clinicos
          </Button>
        </Grid>
        <Grid item xs={12} md={3} lg={3} style={{ textAlign: 'start', margin: '1rem 0' }}>
          <Button
            style={{
              fontSize: '0.8rem',
              padding: 10,
            }}
            variant="contained"
            color="primary"
            onClick={() => {
              const url = 'http://200.69.255.3/viewer/index.php';
              window.open(url, '_blank');
            }}
          >
            Acceso a Visual Medica - Estudios / Imagenes
          </Button>
        </Grid>
        <Grid item xs={12} md={6} lg={6} style={{ textAlign: 'end', margin: '1rem 0' }}>
          <Button
            disabled={false}
            variant="contained"
            color="primary"
            onClick={() => {
              setTituloModal('Solicitud de estudio');
              setOpenModalEstudios(true);
            }}
          >
            + Ingresar estudio solicitado
          </Button>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <Accordion TransitionProps={{ unmountOnExit: true }}>
              <AccordionSummary expandIcon={<ChevronDown />}>
                <Typography variant="h6">Historial de Estudios Solicitados</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {Array.isArray(estudiosSolicitados) && estudiosSolicitados?.length > 0 ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ width: '10%' }}>Nombre Estudio</TableCell>
                        <TableCell style={{ width: '10%' }}>Problema</TableCell>
                        <TableCell style={{ width: '10%' }}>
                          Nombre Profesional
                        </TableCell>
                        <TableCell style={{ width: '10%' }}>
                          Especialidad
                        </TableCell>
                        <TableCell style={{ width: '10%' }}>Fecha</TableCell>
                        <TableCell style={{ width: '30%' }}>Descripción</TableCell>
                        <TableCell style={{ width: '20%' }}> Imágenes</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {estudiosSolicitados.map((estudioS, index) => {
                        return (
                          <EstudiosSolicitadosItem
                            key={estudioS?.id.toString()}
                            estudioS={estudioS}
                          />
                        );
                      })}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
                    No se encuentran informes oftalmológicos
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
